console.log('Welcome to Florida Pole Vault Factory!!!');